// @flow

import withConfig from './withConfig';

export default withConfig;
